module.exports = __webpack_public_path__ + "img/Bookings-Homepage.3b365ec.png";